<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <QTextField v-model="item.Name" :label="$t('servicesystem.common_objects.counter.name')" :rules="[requiredRule]"
          maxlength="50" :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>
    <template v-if="item.Id">
      <v-row>
        <v-col cols="12" class="d-flex align-center">
          <p class="mr-3 mb-0">{{ $t('servicesystem.common_objects.counter.scope') }}:</p>
          <QButtonGroup v-model="scopeMode" :list="scopeOptions" noempty dense color="primary"
            @change="handleFocus(true)">
          </QButtonGroup>
        </v-col>
      </v-row>
      <v-row v-if="!item.Global">
        <v-col cols="12">
          <MachineTypeSelect v-model="item.MachineTypeIds" multiple :externaledit="editMode"
            @FocusState="handleFocus" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <QCheckboxInput v-model="item.Active" :label="$t('servicesystem.common_objects.counter.active')"
            :externaledit="editMode" @FocusState="handleFocus">
          </QCheckboxInput>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>


<script>
import MachineTypeSelect from "@/components/Inputs/EntityDropdowns/MachineTypeSelect2.vue";

export default {
  name: "CounterEditContent",
  props: {
    item: Object,
    editMode: Boolean,
    handleFocus: Function,
  },
  components: {
    MachineTypeSelect,
  },
  mixins: [],

  data() {
    return {
      scopeOptions: [
        { text: this.$t('servicesystem.common_objects.counter.all_machines'), value: 1 },
        { text: this.$t('servicesystem.common_objects.counter.machine_type_specific'), value: 0 }
      ]
    };
  },

  mounted() { },

  methods: {
  },

  computed: {
    scopeMode: {
      get() {
        return this.item.Global ? 1 : 0;
      },
      set(val) {
        this.item.Global = val === 1;
      },
    },
  },

  watch: {},
};
</script>


<style lang='scss'></style>